<template>
    <div v-if="metaData !== null">
        <ul class="ss-pagination">
            <li
                :class="{
                    'prev': true,
                    'disabled': (currentPageForDisplay === 1)
                }">
                <a
                    href="#"
                    @click.prevent.stop="goToPreviousPage()">
                    <i class="fa fa-angle-left"></i>
                </a>
            </li>
            <li
                :key="'page-' + currentPageForDisplay"
                class="pages">
                <span>{{ currentPageForDisplay }}</span> z {{ metaData.last_page }} stron
            </li>
            <li
                :class="{
                    'next': true,
                    'disabled': (currentPageForDisplay === metaData.last_page)
                }">
                <a
                    href="#"
                    @click.prevent.stop="goToNextPage()">
                    <i class="fa fa-angle-right"></i>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "SsPagination",
    props: {
        metaData: {
            default: null,
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
        initialPage: {
            default: 1,
            type: Number
        }
    },
    computed: {
        currentPageForDisplay () {
            if (this.metaData || this.metaData.current_page) {
                return this.metaData.current_page;
            }

            return this.localCurrentPage;
        }
    },
    data () {
        return {
            localCurrentPage: 1
        };
    },
    mounted () {
        this.$bus.$on('pagination-reset', this.goToFirstPage);
        this.localCurrentPage = this.initialPage;
    },
    methods: {
        goToFirstPage () {
            this.localCurrentPage = 1;
            this.triggerChanges();
        },
        goToNextPage () {
            this.localCurrentPage++;

            if (this.localCurrentPage > this.metaData.last_page) {
                this.localCurrentPage = this.metaData.last_page;
            }

            this.triggerChanges();
        },
        goToPreviousPage () {
            this.localCurrentPage--;

            if (this.localCurrentPage < 1) {
                this.localCurrentPage = 1;
            }

            this.triggerChanges();
        },
        triggerChanges () {
            this.$bus.$emit('pagination-page-changed', this.localCurrentPage);
        }
    },
    beforeDestroy () {
        this.$bus.$off('pagination-reset', this.goToFirstPage);
    }
}
</script>

<style lang="scss" scoped>
.prev, .next{
    &.disabled{
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
